import Layout from '@/layout'

const StorageLocationManagementRoutes = {
  path: '/stock/StorageLocation',
  component: Layout,
  name: '存放地点',
  funcPerms: 'stock:product:storelocal',
  meta: {
    title: '存放地点',
    icon: 'location',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'StorageLocation',
      component: () => import('../../../views/oa/StorageLocation/index.vue'),
      funcPerms: 'stock:product:storelocal',
      name: 'StorageLocation',
      meta: {
        title: '存放地点',
        icon: 'location',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'add',
      component: () => import('../../../views/oa/StorageLocation/add.vue'),
      funcPerms: 'stock:hr:manager',
      name: 'StorageLocationAdd',
      hidden: true,
      meta: {
        title: '新增存放地点',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'edit',
      component: () => import('../../../views/oa/StorageLocation/add.vue'),
      funcPerms: 'stock:hr:manager',
      name: 'StorageLocationEdit',
      hidden: true,
      meta: {
        title: '编辑存放地点',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }
  ]
}

export default StorageLocationManagementRoutes
